import type { TourStep } from "../types";

// Several of these cards are role- and state-gated and render nothing most
// of the time (committee seats, the evaluation cards, custodian
// verification, the action bar).
// The DOM-presence filter in ../index drops whichever are absent, so a
// submitter and an SC member get different-length tours from one list.
export const suggestionDetailSteps: TourStep[] = [
  {
    title: "A single suggestion",
    description:
      "Everything on record: the proposal itself, each committee's evaluation, the notes thread, and the full status history.",
  },
  {
    anchor: "detail-status",
    title: "Number and status",
    description:
      "The suggestion number and where it sits in the pipeline. While the suggestion is live the status decides who acts on it next. A final status (Closed – Implemented, or a rejection at WC or SC) means the pipeline has ended and nothing further is expected.",
  },
  {
    anchor: "detail-suggestion-card",
    title: "The proposal",
    description:
      "Title, description, latest remarks and any files the submitter attached. Click an attachment to open it.",
  },
  {
    anchor: "detail-submitter",
    title: "Submitter details",
    description:
      "Who raised the suggestion and their department, alongside the suggestion's own department, unit and category — the fields that decide which committee reviews it. The Reward Category the SC awards lives on the SC evaluation card, next to the score that earned it.",
  },
  {
    anchor: "detail-committee",
    title: "Committee seats",
    description:
      "While the suggestion is still with the custodian, this is where the Work and Steering Committee seats are filled — one picker per seat, saved the moment you choose someone. Once the suggestion moves on, the card goes away and the roster stays visible in the right-hand rail.",
  },
  {
    anchor: "evaluation-wc",
    title: "WC evaluation",
    description:
      "The Works Committee scores the suggestion against the Annexure III criteria. The outcome is not a choice: 30 or more reads as Recommend, anything less as Not Recommend, and the chip updates as you score. It is an editable form while it is the WC's turn, and the read-only record afterwards.",
  },
  {
    anchor: "evaluation-ssc",
    title: "SC evaluation",
    description:
      "The SC scores against Annexure IV; 40 or more approves the suggestion and earns it a reward category, shown on this card next to the total. Approving also asks which departments will verify the benefits — one or several. Same shape as the WC card: editable on its own turn, then read-only.",
  },
  {
    anchor: "detail-implementation",
    title: "Implementation by department",
    description:
      "Once the SC approves, each department it nominated reports its own implementation here, with a comment thread for the detail. The stage closes by itself when the last department is marked done, so nobody has to chase a hand-off.",
  },
  {
    anchor: "detail-verification",
    title: "Review and closure",
    description:
      "The last step. Once every department has implemented, the custodian records the benefits actually observed, attaches the evidence, and closes the suggestion. On a closed suggestion this card is the read-only record of what was reviewed.",
  },
  {
    anchor: "detail-notes",
    title: "Notes",
    description:
      "The running conversation — author, time, text and attachments. The composer only appears while the suggestion is open and you are allowed to add a note at the current stage; a closed suggestion's notes are read-only.",
  },
  {
    anchor: "detail-timeline",
    title: "Status history",
    description:
      "The audit trail: every status change, who made it and when. Below it, the committee members assigned to this suggestion — collapsed, with the count beside the header; click it to see who sits on each committee.",
  },
  {
    anchor: "detail-emails",
    title: "Email notifications",
    description:
      "Every notification this suggestion has sent — the count is beside the header; click it to expand the list, newest first: who each went to, when, and whether it was delivered. Open one to read the email exactly as it landed; custodians can also send it again from here.",
  },
  {
    anchor: "detail-actions",
    title: "Move it forward",
    description:
      "These buttons apply the transitions available from the current status. They only appear for whoever is responsible at this stage, so the set changes as the suggestion advances.",
  },
];
